import React from 'react';
import PropTypes from 'prop-types';
import DateTime from './DateTime';

const DatePicker = ({
  id,
  dateFormat,
  value,
  open,
  locale,
  onChange,
  minDate,
  maxDate,
  showInput,
  className,
  spanClassName,
  viewDate,
  alwaysVisible,
  fullMonth,
  dayRenderingAdditions,
  hideDatePreview,
  showDayText,
  showDayIcon,
}) => (
  <div>
    <DateTime
      id={id}
      readonly
      open={open}
      value={value}
      dateFormat={dateFormat}
      timeFormat={false}
      closeOnSelect
      locale={locale}
      input={showInput}
      viewDate={viewDate}
      onChange={onChange}
      className={className}
      spanClassName={spanClassName}
      minDate={minDate}
      maxDate={maxDate}
      alwaysVisible={alwaysVisible}
      fullMonth={fullMonth}
      dayRenderingAdditions={dayRenderingAdditions}
      hideDatePreview={hideDatePreview}
      showDayText={showDayText}
      showDayIcon={showDayIcon}
      prevIcon={
        <svg width='16' height='16' viewBox='0 0 16 16' fill='#94979c'>
          <polygon points='6.414 8 12.707 1.707 11.293 .293 3.586 8 11.292 15.707 12.706 14.293' />
        </svg>
      }
      nextIcon={
        <svg width='16' height='16' viewBox='0 0 16 16' fill='#94979c'>
          <polygon points='8.879 8 2.586 1.707 4 .293 11.707 8 4.001 15.707 2.587 14.293' />
        </svg>
      }
    />
  </div>
);

DatePicker.propTypes = {
  id: PropTypes.string,
  dateFormat: PropTypes.oneOfType([ PropTypes.string, PropTypes.object, PropTypes.func ]),
  viewDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  locale: PropTypes.string,
  onChange: PropTypes.func,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  className: PropTypes.string,
  spanClassName: PropTypes.string,
  showInput: PropTypes.bool,
  alwaysVisible: PropTypes.bool,
  fullMonth: PropTypes.bool,
  hideDatePreview: PropTypes.bool,
  showDayText: PropTypes.bool,
  showDayIcon: PropTypes.bool,
  open: PropTypes.bool,
  dayRenderingAdditions: PropTypes.arrayOf(PropTypes.object),
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/containers/date-time-picker/DatePicker.js